import FormMaster from '../FormMaster'
import { useTranslation } from 'react-i18next'

const ProductType = () => {
  const { t } = useTranslation(['product-type', 'common'])
  return <FormMaster
    title={t('product_type_information')}
    tableConfig={{
      key: "id",
      apiPath: "product_type/list",
      allowDelete: {
        visible: true,
        key: "product_type_id",
        apiPath: "product_type/delete",
        paramType: 'param'
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'product_type_name',
          caption: t('product_type_name'),
          allowFiltering: true
        },
        {
          dataField: 'description',
          caption: t('description'),
        },
        {
          dataField: 'updated_by',
          caption: t('edited_by'),
        }
      ],
      exportExcel: {
        fileName: t('product_type_information'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('product_type_name'), value: 'product_type_name' },
          { label: t('description'), value: 'description' },
          { label: t('edited_by'), value: 'updated_by' }
        ]
      }
    }}
    formData={{
      product_type_name: "",
      description: ""
    }}
    modalConfig={{
      visible: true,
      title: t('product_type_information'),
      required: ["product_type_name"],
      fieldTypeNumber: [],
      paramName: "product_type_id",
      apiPath: {
        "get": '',
        "post": 'product_type/add',
        "put": 'product_type/update'
      },
      elements: [
        {
          fieldName: "product_type_name",
          label: t('product_type_name'),
          placeholder: t('product_type_name'),
          required: true,
          inputType: "text"
        },
        {
          fieldName: "description",
          label: t('description'),
          placeholder: t('description'),
          rows: 2,
          inputType: "text-area",
          isOneRow: true
        }
      ]
    }}
  />
}

export default ProductType